module.exports = __webpack_public_path__ + "./img-jiudi_f7272ee0858feb7b1ecad0282cf289e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-jiudi.png
// module id = 465
// module chunks = 0